import { Alert, Button, Card, CardContent, CardHeader, FormLabel, Grid, Grid2, Snackbar, TextField } from "@mui/material"
import { useState } from "react";
import { NavigateNextIcon } from '@mui/icons-material/NavigateNext';
import { NavigateNext } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Commons } from "../helper/CommonService";
import { API_HOST } from "../helper/Constant";
import LoadingButton from "@mui/lab/LoadingButton";
import ShowNotif from "../components/general/ShowNotif";

function Login() {
    const navigate = useNavigate(); // Initialize the navigate function
    const [nik, setNik] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [noDaftar, setNoDaftar] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackDetail, setSnackDetail] = useState({});
    const LoginSubmit = () => {
        setIsLoading(true);
        let data = {
            "no_daftar": noDaftar,
            "nik": nik
        }
        Promise.all([
            Commons.PostData(API_HOST + "/loginuser", data),
            Commons.GetData(API_HOST + "/items/tahun_ajarans", "filter[status][_eq]=Active")
        ])
            .then(([loginResponse, tahunAjaranResponse]) => {
                if (loginResponse && tahunAjaranResponse) {
                    setSnackDetail({
                        "status": "success",
                        "message": "Success to login"
                    });
                    let newStorageData = { "id": loginResponse['user']["id"], "tahun_ajaran": tahunAjaranResponse[0]["tahun_ajaran"] };
                    Commons.SaveInStorage(newStorageData);
                    navigate('/main');

                }
            }).catch((err) => {
                console.log(err);
                setSnackDetail({
                    "status": "error",
                    "message": "Fail to login"
                });
            })
            .finally(() => {
                setSnackOpen(true);
                setIsLoading(false);
            });
    }
    return (
        <>
            <Card>
                <CardHeader title="Login Calon Santri" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <ShowNotif actionClose={() => setSnackOpen(false)} isShow={snackOpen} data={snackDetail}></ShowNotif>
                    <Grid spacing={2} sx={{ padding: '25px' }} container>
                        <Grid xs={12} xl={6} lg={6} sm={12} md={4}>
                            <Alert variant="filled" severity="info" sx={{ marginBottom: "15px" }}>
                                Sebelum mengakses informasi calon santri, silahkan isi nomor pendaftaran dan NIK calon santri di kolom berikut:
                            </Alert>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Nomor Pendaftaran</FormLabel>
                            <TextField helperText={"Kolom nomor pendaftaran santri harus diisi."} required name="no_daftar" onChange={(e) => { setNoDaftar(e.target.value) }} fullWidth></TextField>
                        </Grid>
                        <Grid xs={0} lg={6} xl={6} sm={0} md={8}>
                        </Grid>
                        <Grid xs={12} lg={6} xl={6} sm={12} md={4}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Nomor Induk Kependidikan (NIK) Calon Santri</FormLabel>
                            <TextField helperText={"Kolom NIK santri harus diisi."} required name="nik" onChange={(e) => { setNik(e.target.value) }} fullWidth></TextField>
                            <LoadingButton
                                loading={isLoading}
                                loadingPosition="start"
                                style={{ backgroundColor: "#e96726", color: "white" }}
                                startIcon={<NavigateNext></NavigateNext>}
                                variant="outlined"
                                fullWidth
                                onClick={() => { LoginSubmit(); }}                            >
                                {isLoading ? "Processing" : "Login"}
                            </LoadingButton>
                        </Grid>
                        <Grid xs={0} lg={6} xl={6} sm={0} md={8}></Grid>
                    </Grid>
                </CardContent>
            </Card>

        </>);
}
export default Login;